import { useEffect, useState } from 'react';
import './AppVersion.css';

function AppVersion() {
  const [version, setVersion] = useState('');

  useEffect(() => {
    fetch('/version.txt')
      .then(res => res.text())
      .then(data => setVersion(data.trim()))
      .catch(() => setVersion(''));
  }, []);

  if (!version) return null;

  return (
    <div className="app-version">
      v{version}
    </div>
  );
}

export default AppVersion;
